<template>
  <div>
    <div class="h-114" />
    <div class="tabs h-114">
      <div
        class="tab"
        v-for="item in options"
        :key="item.key"
        :class="{ active: item.key === curTab }"
        @click="() => handleTabClick(item.key)"
      >
        {{ item.text }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Tabs',
  props: {
    options: {
      type: Array,
      default: () => []
    },
    curTab: {
      type: String,
      default: ''
    }
  },
  data() {
    return {};
  },
  methods: {
    handleTabClick(key) {
      this.$emit('tabClick', key);
    }
  }
};
</script>

<style lang="scss" scoped>
.tabs {
  width: 100vw;
  height: 114px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  position: fixed;
  top: 0px;
  left: 0px;
  z-index: 999;
  background-color: #ffffff;
  padding-top: 27px;
  box-sizing: border-box;

  .tab {
    flex: 1;
    font-size: 32px;
    color: #787878;
    letter-spacing: 0;
    text-align: center;
    font-weight: 400;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    &.active {
      font-size: 35px;
      color: #383838;
      letter-spacing: 0;
      text-align: center;
      font-weight: bold;
      position: relative;

      &::after {
        content: "";
        width: 54px;
        height: 4px;
        background: #FE7256;
        border-radius: 2%;
        position: absolute;
        left: 50%;
        bottom: 0px;
        transform: translateX(-50%);
      }
    }
  }
}
.h-114 {
  height: 114px;
}
</style>
